/**
 * Main menu management
 */

import PubSub from "pubsub-js";

class Menu {
    constructor() {
        
        const menuItems = document.querySelectorAll('.js-menu');
        const menuSubItems = document.querySelectorAll('.js-menu__sub');
        const menuLinks = document.querySelectorAll('.c-menu a');

        // --- CLOSE OPEN SUBMENUS WHEN SELECTING A MAIN MENU ITEM  ---

        PubSub.subscribe('toggleClose', (e, btn) => {
            if (btn.classList.contains('js-menu')) {
                let targetId = btn.getAttribute('aria-controls');
                if (targetId) {
                    let childToggles = document.querySelectorAll('#' +targetId+ ' .js-menu__sub');
                    for (let i=0; i < childToggles.length; i++) {
                        // Close any open submenus
                        if (childToggles[i].getAttribute('aria-expanded') === 'true') {
                            childToggles[i].click(); // triggers doToggle()
                        }
                    }
                }
            }
        });

        // --- CLOSE MENU PANELS WHEN SWAPPING PAGE ---

        htmx.on('htmx:pushedIntoHistory', (event) => {
            manageMenu(String(event.detail.path));
        });

        htmx.on('htmx:historyRestore', (event) => {
            manageMenu(String(event.detail.path));
        });

        function manageMenu(requestedUrl) {

            const root = location.protocol + '//' + location.host;

            // normalise requested URL
            if (requestedUrl.startsWith('/')) {
                requestedUrl = root + requestedUrl;
            }

            // primary menu toggle buttons
            for (let i=0; i < menuItems.length; i++) {
                // Close any open main menus
                if (menuItems[i].getAttribute('aria-expanded') === 'true') {
                    menuItems[i].click(); // triggers doToggle()
                    menuItems[i].focus(); // will return focus to last button in sequence
                }
            }

            // sub menu toggle buttons
            for (let i=0; i < menuSubItems.length; i++) {
                // Close any open submenus
                if (menuSubItems[i].getAttribute('aria-expanded') === 'true') {
                    menuSubItems[i].click(); // triggers doToggle()
                }
            }

            // menu links
            // => Set the current page (aria-current="page") or parent (aria-current="true")
            for (let i=0; i < menuLinks.length; i++) {

                let link = menuLinks[i].getAttribute('href');
                if (link) {
                    if (link.startsWith('/')) {
                        link = root + buttonUrl;
                    }
                    if (requestedUrl === link) {
                        menuLinks[i].setAttribute('aria-current', 'page');
                    } else if (requestedUrl.startsWith(link)) {
                        menuLinks[i].setAttribute('aria-current', 'true');
                    } else {
                        menuLinks[i].removeAttribute('aria-current');
                    }
                }
            }

        }
    }
}

export default Menu;